var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15.1429V2.33094C1 1.59574 1.61566 1 2.375 1H10.625C11.3843 1 12 1.59574 12 2.33094V15.1429L6.5 11.3992L1 15.1429Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15.1429V2.33094C1 1.59574 1.61566 1 2.375 1H10.625C11.3843 1 12 1.59574 12 2.33094V15.1429L6.5 11.3992L1 15.1429Z",
    fill: "#183242",
    stroke: "#183242",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkedLogo);
export default __webpack_public_path__ + "static/media/bookmarkedLogo.a29cd0dfa27e8b855086bdb0e48e2536.svg";
export { ForwardRef as ReactComponent };